(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('faq-page')) return;

    const normalize = (value) =>
      (value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/\s+/g, ' ')
        .trim();

    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class FaqPage extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
        this.groups = Array.from(this.querySelectorAll('[data-faq-group]'));
        this.navLinks = Array.from(this.querySelectorAll('[data-faq-nav]'));
        this.input = this.querySelector('[data-faq-search]');
        this.clearButton = this.querySelector('[data-faq-clear]');
        this.status = this.querySelector('[data-faq-status]');
        this.empty = this.querySelector('[data-faq-empty]');
        this.index = this.items.map((item) => ({ item, text: normalize(item.textContent) }));

        this.onInput = () => this.filter(this.input.value);
        this.onClear = () => {
          this.input.value = '';
          this.filter('');
          this.input.focus();
        };
        this.onHashChange = () => this.openFromHash();
        this.onNavClick = (event) => this.scrollToGroup(event);
        this.onBlockSelect = (event) => {
          const item = event.target.closest && event.target.closest('[data-faq-item]');
          if (item && this.contains(item)) item.open = true;
        };

        if (this.input) this.input.addEventListener('input', this.onInput);
        if (this.clearButton) this.clearButton.addEventListener('click', this.onClear);
        this.navLinks.forEach((link) => link.addEventListener('click', this.onNavClick));
        window.addEventListener('hashchange', this.onHashChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.openFromHash();
        this.observeGroups();
      }

      disconnectedCallback() {
        window.removeEventListener('hashchange', this.onHashChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.observer) this.observer.disconnect();
      }

      filter(rawValue) {
        const terms = normalize(rawValue).split(' ').filter(Boolean);
        const searching = terms.length > 0;
        let visible = 0;

        this.index.forEach(({ item, text }) => {
          const match = !searching || terms.every((term) => text.includes(term));
          item.hidden = !match;
          if (match) visible += 1;
          if (item.dataset.searchOpened && (!searching || !match)) {
            item.open = false;
            delete item.dataset.searchOpened;
          }
        });

        if (searching && visible > 0 && visible <= 3) {
          this.index.forEach(({ item }) => {
            if (!item.hidden && !item.open) {
              item.open = true;
              item.dataset.searchOpened = 'true';
            }
          });
        }

        this.groups.forEach((group) => {
          const visibleInGroup = group.querySelectorAll('[data-faq-item]:not([hidden])').length;
          group.hidden = visibleInGroup === 0;
          if (group.id) {
            const navItem = this.querySelector(`[data-faq-nav-item="${group.id}"]`);
            if (navItem) {
              navItem.hidden = visibleInGroup === 0;
              const count = navItem.querySelector('[data-faq-nav-count]');
              if (count) count.textContent = String(visibleInGroup);
            }
          }
        });

        if (this.empty) this.empty.hidden = !(searching && visible === 0);
        if (this.clearButton) this.clearButton.hidden = !rawValue;
        if (this.status) {
          this.status.textContent = searching ? `${visible} ${visible === 1 ? 'result' : 'results'}` : '';
        }
      }

      openFromHash() {
        const id = decodeURIComponent(window.location.hash.slice(1));
        if (!id) return;
        const target = this.querySelector(`#${CSS.escape(id)}`);
        if (target && target.matches('[data-faq-item]')) {
          target.open = true;
          requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
        }
      }

      scrollToGroup(event) {
        const link = event.currentTarget;
        const target = this.querySelector(link.hash);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', link.hash);
        this.setCurrent(target.id);
      }

      setCurrent(id) {
        this.navLinks.forEach((link) => {
          if (link.hash === `#${id}`) {
            link.setAttribute('aria-current', 'true');
            if (window.matchMedia('(max-width: 989px)').matches) {
              link.scrollIntoView({ block: 'nearest', inline: 'center' });
            }
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      observeGroups() {
        if (!this.navLinks.length || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setCurrent(entry.target.id);
            });
          },
          { rootMargin: '-20% 0px -70% 0px' }
        );
        this.groups.forEach((group) => {
          if (group.id) this.observer.observe(group);
        });
      }
    }

    customElements.define('faq-page', FaqPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
